import {useEffect, useState} from 'react';
import {useApp} from '../../../contexts/AppContext';
import {sendInquiry, sendInquiryAuth} from '../../../api';
import styled from 'styled-components';
import config from '../../../config';
import {
  PageMainTitle,
  SubInner,
  InputLabel,
  FormTextArea,
  RequiredLabel,
  FormInput,
} from '../../atoms/CommonParts';
import DBDPullDown from '../../atoms/DBDPullDown';
import {useAuth} from '../../../contexts/UserContext';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';
import {Link, useLocation} from 'react-router-dom';

const Page = styled.div`
  @media ${config.layout.wide} {
  }
`;

const ThanksTitle = styled.h3`
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  @media ${config.layout.wide} {
    margin-top: 60px;
  }
`;

const ThanksDescription = styled.div`
  font-size: 14px;
  line-height: 26px;
  font-weight: bold;
  padding-bottom: 50px;
  border-bottom: 1px solid #000000;
  margin-bottom: 70px;
  text-align: center;
  @media ${config.layout.wide} {
    padding-bottom: 60px;
    margin-bottom: 80px;
  }
`;

const KeepMeLogin = styled.div`
  text-align: center;
  margin: 50px auto;
  max-width: calc(100% - 30px);
  @media ${config.layout.wide} {
    max-width: 100%;
  }

  input {
    display: none;
  }

  label {
    position: relative;
    font-size: 12px;
    @media ${config.layout.wide} {
      font-size: 14px;
    }
    font-weight: 500;
    margin-left: 7px;
    padding-left: 28px;
    text-align: left;

    a {
      color: #000000;
    }
  }
`;

function ContactSent() {
  return (
      <Page>
        <PageMainTitle
        >
          <span>Contact</span>
        </PageMainTitle>
        <ThanksTitle>Thank you!</ThanksTitle>
        <ThanksDescription>
          Your request was submitted successfully. We'll respond as soon as
          possible to the e-mail address of your AlphaTheta Account.
        </ThanksDescription>
        <Link
            className="dark-button back-button center-fixed primary"
            to={`/`}
            style={{}}
        >
          <span>Home</span>
        </Link>
      </Page>
  );
}

function ContactUnauth({setSent}) {
  const {state} = useLocation();
  const [category, setCategory] = useState(
      (state && state.category) || 'default',
  );
  const {customDialog, errorDialogWithAPIError} = useCustomDialog();
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    document.title = 'Contact';
    try {
      let st = window.history.state;
      if (st && st.usr && st.usr.category) {
        delete st.usr.category;
        window.history.replaceState(st, document.title);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const categories = [
    'Inquiry',
    'Forgot my e-mail to resend the KUVO ID',
    `Can't log in`,
    'Error',
    'Others',
  ].map((v) => {
    return {
      value: v,
      label: v,
    };
  });

  function handleSubmit(event) {
    event.preventDefault();

    if (!agreed) {
      return;
    }

    let formData = new FormData(event.currentTarget);
    let name = (formData.get('name') || '').trim().substr(0, 256);
    let email = (formData.get('email') || '').trim().substr(0, 256);
    let description = (formData.get('description') || '').trim();
    let errors = [];
    if (!name) {
      errors.push('- Name is required.');
    }
    if (!email) {
      errors.push('- E-mail is required.');
    }
    if (category == 'default') {
      errors.push('- Choose a category.');
    }
    if (!description) {
      errors.push('- Comment is required.');
    }

    if (errors.length) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                {errors.map((e, i) => {
                  return <li key={i}>{e}</li>;
                })}
              </ul>
          ),
        });
      })();
      return;
    }

    (async () => {
      try {
        await sendInquiry({
          name,
          email,
          category,
          description,
        });
        setSent(true);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
      } catch (e) {
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  }

  const onCategoryPullDownChange = (newValue) => {
    console.log(newValue);
    setCategory(newValue);
  };

  return (
      <Page>
        <PageMainTitle>
          <span>Contact</span>
        </PageMainTitle>
        <SubInner
            style={{
              paddingTop: 30,
            }}
        >
          <form onSubmit={handleSubmit}>
            <RequiredLabel/>
            <InputLabel required={true}>Name</InputLabel>
            <FormInput type="text" required name="name" maxLength={64}
                       onInvalid={(e) => {
                         if (window.scrollY > 140) {
                           window.scrollTo(0, 140);
                         }
                       }}/>
            <InputLabel required={true}>E-mail</InputLabel>
            <FormInput type="email" required name="email" maxLength={128}
                       onInvalid={(e) => {
                         if (window.scrollY > 140) {
                           window.scrollTo(0, 140);
                         }
                       }}/>
            <InputLabel required={true}>Subject</InputLabel>
            <DBDPullDown
                defaultLabel={'Select one'}
                value={category}
                onChange={onCategoryPullDownChange}
                items={categories}
                style={{
                  minWidth: '100%',
                }}
            ></DBDPullDown>
            <InputLabel required={true}>Questions/comments</InputLabel>
            <FormTextArea required={true} name="description" maxLength={1000}/>

            <KeepMeLogin>
              <input
                  id="keep_me_logged_in"
                  name="keep"
                  type="checkbox"
                  defaultChecked={agreed}
                  onChange={(e) => {
                    setAgreed(e.target.checked);
                  }}
              />
              <label htmlFor="keep_me_logged_in" className={"checkbox-label"}>
                I agree to the{' '}
                <a
                    href="https://alphatheta.com/company/privacy-policy/"
                    target="_blank"
                    rel="noopener"
                >
                  Privacy Policy
                </a>, including the transfer of my personal information to Japan
                and the U.S.
                for hosting purpose and to provide you with the service. I
                understand that these countries may not have
                the same data protection laws as the country from which I
                provide my personal information. I have the
                right to withdraw my consent at any time.
              </label>
            </KeepMeLogin>

            <button
                type="submit"
                className="dark-button center-fixed primary"
                style={{
                  margin: '50px  auto 0',
                }}
                disabled={!agreed}
            >
              <span>Submit</span>
            </button>
          </form>
        </SubInner>
      </Page>
  );
}

function ContactAuth({setSent}) {
  const {state} = useLocation();
  const [category, setCategory] = useState(
      (state && state.category) || 'default',
  );
  const {customDialog, errorDialogWithAPIError} = useCustomDialog();

  useEffect(() => {
    try {
      let st = window.history.state;
      if (st && st.usr && st.usr.category) {
        delete st.usr.category;
        window.history.replaceState(st, document.title);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const categories = [
    'Inquiry',
    'Request to change my venue name',
    'Request to delete my venue account',
    'Error',
    'Others',
  ].map((v) => {
    return {
      value: v,
      label: v,
    };
  });

  function handleSubmit(event) {
    event.preventDefault();
    let formData = new FormData(event.currentTarget);
    let description = (formData.get('description') || '').trim();
    let errors = [];
    if (category == 'default') {
      errors.push('- Choose a category.');
    }
    if (!description) {
      errors.push('- Comment is required.');
    }

    if (errors.length) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                {errors.map((e, i) => {
                  return <li key={i}>{e}</li>;
                })}
              </ul>
          ),
        });
      })();
      return;
    }

    (async () => {
      try {
        await sendInquiryAuth({
          category,
          description,
        });
        setSent(true);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
      } catch (e) {
        console.error(e);
        await errorDialogWithAPIError(e);
      }
    })();
  }

  const onCategoryPullDownChange = (newValue) => {
    setCategory(newValue);
  };

  return (
      <Page>
        <PageMainTitle>
          <span>Contact</span>
        </PageMainTitle>
        <SubInner
            style={{
              paddingTop: 30,
            }}
        >
          <form onSubmit={handleSubmit}>
            <RequiredLabel/>
            <InputLabel required={true}>Subject</InputLabel>
            <DBDPullDown
                defaultLabel={'Select one'}
                value={category}
                onChange={onCategoryPullDownChange}
                items={categories}
                style={{
                  minWidth: '100%',
                }}
            ></DBDPullDown>
            <InputLabel required={true}>Questions/comments</InputLabel>
            <FormTextArea required={true} name="description" maxLength={1000}/>
            <button
                type="submit"
                className="dark-button center-fixed primary"
                style={{
                  margin: '50px  auto 0',
                }}
            >
              <span>Submit</span>
            </button>
          </form>
        </SubInner>
      </Page>
  );
}

export default function ContactPage() {
  const app = useApp();
  const auth = useAuth();
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (auth.isLoggedIn()) {
      app.showHeader();
    } else {
      app.showHeader(true);
    }
  }, []);

  if (sent) {
    return <ContactSent/>;
  } else if (auth.isLoggedIn()) {
    return <ContactAuth setSent={setSent}/>;
  } else {
    return <ContactUnauth setSent={setSent}/>;
  }
}
